import React from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentContentOptimizer } from '../../../../pages/contentOptimizer/contentPage/store/contentOptimizerContent.selectors';
import { selectContentOptimizerViewOnlyMode } from '../../../../pages/contentOptimizer/viewOnly/store/viewOnlySettings.selectors';
import { selectAIStateLoading, selectGeneratedAIToken } from '../../store/tiptapEditor.selectors';

import { headingOptions } from '../constants';

import AISection from '../buttons/AISection';
import AIWordCounter from '../buttons/AIWordCounter';
import GalleryButtonsSection from '../buttons/GalleryButtonsSection';
import HeadingSection from '../buttons/HeadingSection';
import ListButtonsSection from '../buttons/ListButtonsSection';
import MarkButtonsSection from '../buttons/MarkButtonsSection';
import UndoRedoButtonsSection from '../buttons/UndoRedoButtonsSection';
import { useIsAIContentGeneration } from '../../../../../utils/hooks/useIsAIContentGeneration';

const OptimizerEditorToolbarSections = () => {
    const aiAppId = process.env.REACT_APP_TIPTAP_AI_APP_ID;

    const viewOnlyMode = useSelector(selectContentOptimizerViewOnlyMode);
    const currentContentOptimizer = useSelector(selectCurrentContentOptimizer);
    const generatedAIToken = useSelector(selectGeneratedAIToken);
    const aiLoading = useSelector(selectAIStateLoading);
    const { isAIContentGeneration } = useIsAIContentGeneration();
    const isDisabledWholeToolbar = aiLoading || isAIContentGeneration;

    return (
        <>
            <HeadingSection disabled={isDisabledWholeToolbar} headingOptions={headingOptions} />
            <MarkButtonsSection disabled={isDisabledWholeToolbar} />
            <ListButtonsSection disabled={isDisabledWholeToolbar} />
            <GalleryButtonsSection disabled={isDisabledWholeToolbar} />
            <UndoRedoButtonsSection disabled={isDisabledWholeToolbar} />
            {generatedAIToken &&
                aiAppId &&
                (currentContentOptimizer?.organization_settings?.ai_command_menu_for_shared_links ||
                    !viewOnlyMode) && (
                    <>
                        <AISection />
                        <AIWordCounter />
                    </>
                )}
        </>
    );
};

export default OptimizerEditorToolbarSections;
